// Overnight lock on PI edits. Mirrors the backend gate (order/estimate_edit_window.py), which
// refuses PI edits — Edit PI, address changes, additional charges — and the OMS order-level
// actions (cancel, sync items, billing reconcile, change address, unloading charge, express) from
// 10 PM to 8 AM IST to anyone without `pi.edit_after_hours` (admin only, managed in Branch →
// Permissions). Placing orders, status changes and the rest stay open. This side only disables
// the buttons; the backend is what enforces it.

export const PI_EDIT_AFTER_HOURS_PERMISSION = "pi.edit_after_hours";
export const PI_EDIT_LOCKED_MESSAGE =
  "This can't be done between 10 PM and 8 AM IST. Only admins can do it now.";

const IST_OFFSET_MINUTES = 5 * 60 + 30;
const LOCK_STARTS_HOUR = 22;
const LOCK_ENDS_HOUR = 8;

/** True between 22:00 and 08:00 IST, whatever timezone the browser is in. */
export const isInPIEditLockWindow = (now: Date = new Date()) => {
  const istMinutes =
    (now.getUTCHours() * 60 + now.getUTCMinutes() + IST_OFFSET_MINUTES) % (24 * 60);
  const istHour = Math.floor(istMinutes / 60);
  return istHour >= LOCK_STARTS_HOUR || istHour < LOCK_ENDS_HOUR;
};

/** Why this user can't edit a PI right now, or null if they can. */
export const piEditLockReason = (
  hasPermission: (permission: string) => boolean,
  now: Date = new Date()
) =>
  isInPIEditLockWindow(now) && !hasPermission(PI_EDIT_AFTER_HOURS_PERMISSION)
    ? PI_EDIT_LOCKED_MESSAGE
    : null;
